import React from 'react';
import Slider from '../Slider';
import PercentageBtns from './PercentageBtns';

type Props = {
  value: number;
  onChange: (value: number) => void;
  onTouchEnd?: (value: number) => void;
  onMouseUp?: (value: number) => void;
  disabled?: boolean;
  availableAmount?: string;
  availableAmountLabel?: string;
};

const PercentageSelector: React.FC<Props> = (props) => {
  return (
    <>
      <div className="flex flex-row justify-between items-center mt-3 mb-2">
        <div className="font-medium">
          <span className="text-gray-400">{props.availableAmountLabel}</span>{' '}
          {props.availableAmount}
        </div>
        <PercentageBtns
          onChange={props.onChange}
          disabled={props.disabled}
        />
      </div>
      <Slider
        value={props.value}
        onChange={props.onChange}
        onMouseUp={props.onMouseUp}
        onTouchEnd={props.onTouchEnd}
        disabled={props.disabled}
      />
    </>
  );
};

export default PercentageSelector;
